// Company Information
export const COMPANY_INFO = {
    name: "TOPFLUXE INC",
    tagline: "Transform Your Business with Smart IT Solutions",
    shortDescription: "IT Solutions & Consulting",
    email: "kiran@topfluxeinc.com",
    phone: "+1 (647) 537-9398",
    address: {
        street: "56 HavendaleRd",
        city: "Scarborough",
        state: "ON",
        zip: "M1S 1E2",
        country: "Canada"
    },
    social: {
        linkedin: "https://www.linkedin.com/company/topfluxe-inc/"
    }
};

// Logo SVG as data URI
export const LOGO_SVG = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 100 100'%3E%3Cpath d='M20 80V20h20v30h20L60 70z' fill='%23E63946'/%3E%3Cpath d='M60 50h25v20H60z' fill='%23555'/%3E%3C/svg%3E";


// Services
export const SERVICES = [
    {
        id: 1,
        icon: "💻",
        title: "Custom Software Development",
        shortDesc: "Build scalable, secure applications tailored to your business needs.",
        description: "From web applications to enterprise software, we develop custom solutions that streamline operations and drive business growth. Our experienced developers use modern technologies to create robust, user-friendly applications.",
        deliverables: [
            "Web & mobile applications",
            "API development & integration",
            "Database design & optimization",
            "Ongoing maintenance & updates"
        ]
    },
    {
        id: 2,
        icon: "☁️",
        title: "Cloud Solutions & Infrastructure",
        shortDesc: "Cloud migration, setup, and management across AWS, Azure, and Google Cloud.",
        description: "We help businesses migrate to the cloud and optimize their infrastructure. Our team handles architecture design, deployment, and ongoing management to ensure scalability, security, and cost-efficiency.",
        deliverables: [
            "Cloud infrastructure setup",
            "Migration strategy & execution",
            "Cost optimization",
            "24/7 monitoring & support"
        ]
    },
    {
        id: 3,
        icon: "🔒",
        title: "Cybersecurity Solutions",
        shortDesc: "Protect your business from modern security threats.",
        description: "From security audits to compliance management, we ensure your systems are secure. We implement industry best practices, conduct vulnerability assessments, and provide ongoing security monitoring to protect your data and operations.",
        deliverables: [
            "Security assessment & auditing",
            "Vulnerability testing",
            "Compliance management",
            "Incident response planning"
        ]
    },
    {
        id: 4,
        icon: "💼",
        title: "IT Staffing & Recruitment",
        shortDesc: "Connect with top-tier IT talent for full-time, contract, and project-based roles.",
        description: "We specialize in placing skilled IT professionals across various domains. From software developers to cloud architects, we match the right talent with your business needs, ensuring seamless integration and project success.",
        deliverables: [
            "Full-time & contract placements",
            "Technical screening & vetting",
            "Cultural fit assessment",
            "Onboarding support"
        ]
    },
    {
        id: 5,
        icon: "📝",
        title: "Resume Optimization & Career Support",
        shortDesc: "Professional resume optimization and candidate marketing services.",
        description: "Help IT professionals stand out in the competitive tech landscape. Our experts optimize resumes, highlight key achievements, and provide career guidance to accelerate professional growth and job placement success.",
        deliverables: [
            "Professional resume writing",
            "LinkedIn profile optimization",
            "Interview preparation",
            "Career counseling"
        ]
    },
    {
        id: 6,
        icon: "🔧",
        title: "IT Infrastructure Management",
        shortDesc: "Comprehensive IT infrastructure setup and managed services.",
        description: "We provide end-to-end infrastructure management including network setup, server configuration, security implementation, and ongoing maintenance. Keep your systems running smoothly while we handle the technical complexities.",
        deliverables: [
            "Network design & setup",
            "Server configuration",
            "Security implementation",
            "Proactive maintenance"
        ]
    },
];

// Case Studies
export const CASE_STUDIES = [
    {
        id: 1,
        client: "HealthTech Startup",
        industry: "Healthcare",
        challenge: "Needed HIPAA-compliant cloud infrastructure",
        solution: "Migrated to AWS with full compliance, implemented automated backups and disaster recovery",
        result: "100% uptime in first year, 40% cost reduction",
        logo: "🏥"
    },
    {
        id: 2,
        client: "E-Commerce Platform",
        industry: "Retail",
        challenge: "Website couldn't handle traffic spikes during sales",
        solution: "Re-architected backend with auto-scaling infrastructure on Azure",
        result: "5x traffic capacity, 60% faster page loads",
        logo: "🛒"
    },
    {
        id: 3,
        client: "Financial Services Firm",
        industry: "Finance",
        challenge: "Security audit revealed critical vulnerabilities",
        solution: "Implemented comprehensive security framework, achieved SOC 2 compliance",
        result: "Passed SOC 2 audit, zero security incidents",
        logo: "💰"
    }
];

// Clients
export const CLIENTS = [
    { name: "Financial Services", logo: "🏦", role: "Cloud Migration & IT Staff Augmentation" },
    { name: "Healthcare Tech", logo: "⚕️", role: "Software Development & Security Consulting" },
    { name: "E-Commerce Platform", logo: "🛒", role: "Infrastructure Management & DevOps Engineers" },
    { name: "EdTech Company", logo: "📚", role: "Full-Stack Developers & Cloud Architects" },
    { name: "FinTech Startup", logo: "💰", role: "Cybersecurity & Backend Developers" },
    { name: "SaaS Provider", logo: "☁️", role: "IT Staffing & Cloud Solutions" }
];

// About Content
export const ABOUT_CONTENT = {
    intro: "At Topfluxe Inc., we empower businesses with innovative IT Services and Staffing Solutions designed to drive growth, efficiency, and digital transformation.",
    paragraph1: "We understand that technology and talent are the backbone of every successful organization. That's why we combine our deep expertise in IT consulting with strategic staffing capabilities—helping companies build agile teams, optimize operations, and stay ahead in today's fast-changing digital world.",
    paragraph2: "Whether you need end-to-end IT solutions or skilled professionals to accelerate your projects, our team is committed to delivering excellence, reliability, and measurable results. From infrastructure management and cloud services to recruitment, resume optimization, and candidate marketing, Topfluxe serves as your trusted partner every step of the way.",
    mission: {
        title: "Our Mission",
        text: "To connect innovation with opportunity—empowering businesses and professionals to achieve their full potential through technology and talent."
    },
    vision: {
        title: "Our Vision",
        text: "To be a leading global partner for IT services and staffing, known for our commitment to quality, integrity, and customer success."
    },
    offerings: {
        title: "What We Offer",
        items: [
            {
                title: "IT Consulting & Services",
                text: "Infrastructure setup, cloud solutions, software development, and managed services."
            },
            {
                title: "Recruitment & Staffing",
                text: "Matching top-tier IT talent with full-time, contract, and project-based roles."
            },
            {
                title: "Career Support",
                text: "Resume optimization and candidate marketing to help professionals shine in the competitive tech landscape."
            }
        ]
    }
};

// FAQs
export const FAQS = [
    {
        id: 1,
        question: "How do you price your services?",
        answer: "We offer both project-based pricing and monthly retainers, depending on your needs. We'll provide a detailed quote after an initial consultation to understand your requirements."
    },
    {
        id: 2,
        question: "What size companies do you work with?",
        answer: "We specialize in startups and SMBs (10-500 employees), but we've worked with organizations of all sizes. If you're growing fast and need reliable IT support, we can help."
    },
    {
        id: 3,
        question: "Do you offer ongoing support after project completion?",
        answer: "Yes! We offer maintenance packages and support retainers to ensure your systems stay secure and up-to-date. Many clients stay with us long-term."
    },
    {
        id: 4,
        question: "How quickly can you start?",
        answer: "For most projects, we can start within 1-2 weeks after the initial consultation and proposal approval. Emergency support can often begin within 24-48 hours."
    },
    {
        id: 5,
        question: "Do you work remotely or on-site?",
        answer: "We're flexible! Most of our work is done remotely, but we can arrange on-site visits for meetings, training, or hands-on work when needed."
    }
];

// Stats
export const STATS = [
    { number: "20+", label: "Projects Completed" },
    { number: "20+", label: "Happy Clients" },
    { number: "99.9%", label: "Uptime Delivered" },
    { number: "3", label: "Years Experience" }
];

// Business Hours
export const BUSINESS_HOURS = {
    weekdays: "Monday - Friday: 9:00 AM - 5:00 PM EST",
    weekend: "Weekend: By appointment",
    response: "We typically respond within 2 business days"
};

// Process
export const PROCESS = [
    {
        step: 1,
        title: "Discovery Call",
        description: "We start with a free 30-minute call to understand your challenges and goals."
    },
    {
        step: 2,
        title: "Proposal & Planning",
        description: "We create a detailed proposal with timeline, deliverables, and transparent pricing."
    },
    {
        step: 3,
        title: "Execution",
        description: "Our team gets to work, keeping you updated with regular check-ins and progress reports."
    },
    {
        step: 4,
        title: "Delivery & Support",
        description: "We deliver on time, train your team, and provide ongoing support as needed."
    }
];

// Service Labels
export const SERVICE_LABELS = {
  software: 'Software Development',
  cloud: 'Cloud Solutions',
  security: 'Cybersecurity',
  resume: 'Resume Optimization',
  staffing: 'IT Staffing & Recruitment',
  infrastructure: 'Infrastructure Management',
  general: 'General Inquiry'
};